export enum RuleField {
    // Warehouse
    EAN = 'ean',
    CONNECTION_ID = 'connectionId',
    SOURCE = 'source',

    // Bol
    FULFILMENT_METHOD = 'fulfilmentMethod',
    TYPE = 'type',
    STOCK_MANAGED_BY_RETAILER = 'stockManagedByRetailer',

    // Monta
    WAREHOUSE = 'warehouse',
    LOCATION = 'location',

    // File
    SHEET_NAME = 'sheetName',
    HEADER_ROW_INDEX = 'headerRowIndex',
    EAN_COLUMN_NAME = 'eanColumnName',
    QUANTITY_COLUMN_NAME = 'quantityColumnName',
    FILE_TYPE = 'fileType',
    DELIMITER = 'delimiter',
}